import styled from "styled-components";

// Высоту задаёт обёртка: chart.js рисует в canvas и растягивается по родителю, а без
// фиксированной высоты родителя канвас схлопывается в ноль.
export const Wrapper = styled.div<{ $height: number }>`
    position: relative;
    width: 100%;
    height: ${(props) => props.$height}px;
`;
